import { createContext, useContext, useEffect, useState } from "react";
import { api, whenTermsRequired } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null=loading, false=anon, obj=user
  const [ready, setReady] = useState(false);

  const loadMe = async () => {
    const token = localStorage.getItem("cb_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("cb_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => { loadMe(); whenTermsRequired(() => loadMe()); }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const setSession = (data) => {
    localStorage.setItem("cb_token", data.access_token);
    setUser(data.user);
    loadMe();  // the whole picture, e.g. whether updated terms wait (only /me says)
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("cb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, setSession, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}
